import { render } from "./ScoreSetting.vue?vue&type=template&id=40871aa5"
import script from "./ScoreSetting.vue?vue&type=script&lang=js"
export * from "./ScoreSetting.vue?vue&type=script&lang=js"

import "./ScoreSetting.vue?vue&type=style&index=0&id=40871aa5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__